import store from "@/store";

class LazadaMessage {

	static getInstance() {
	  if (!this.instance) {
	    this.instance = new LazadaMessage();
	  }
	  return this.instance;
	}

	new_message(message) {
		if (message.sync_type && message.sync_type == 'SESSION_UPDATE') {
			store.commit("lazada/updateSession", message);
		} else {		
			store.commit("lazada/messageHanle", message);
			store.commit("lazada/updateMessage", message.message);
		}
	}

	session_list(message) {
		for (let i in message) {
			store.commit("lazada/setSessionData", message[i]);			
		}

	}

	invitation(message) {
		store.commit("lazada/invitationSession", message);
	}

	transfer(message) {
		console.log(message);
		store.commit("lazada/transferSession", message);
	} 

}

export default LazadaMessage.getInstance();